import { render, staticRenderFns } from "./TagPolicies.vue?vue&type=template&id=5aacc822&"
import script from "./TagPolicies.vue?vue&type=script&lang=js&"
export * from "./TagPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports